const messages = {
  logout: '로그아웃',
  help: '도움말',
  // menu list
  gridExample: '레이아웃 그리드 및 반응형 샘플',
  buttonsetExample: '버튼 샘플',
  realgridExample: '리얼그리드 샘플',
  highchartExample: '하이차트 샘플',
  tableGuide: '테이블 샘플',
  popupExample: '팝업 샘플',
  formGuide: 'Form 샘플',
  uploadExample: 'Upload 샘플',
  RealgridComponetExample: '리얼그리드 컴포넌트 샘플',
  RealgridResponsiveExample: '리얼그리드 반응형 샘플',
  noticeboard: '공지 게시판 샘플',
  dashboard1: '대시보드 타입 1',
  dashboard2: '대시보드 타입 2',
  managerMenu: '메뉴관리',
  ManagerUser: '사용자 관리',
  noticeBoard: '게시판',
  managerUserToast: '사용자관리Toast',
  DashboardByUser: '사용자대시보드',
  'code-regist': '코드 등록',
  'code-modify': '코드 수정',
  Echart: '이차트',
  // footer
  address: '(44032) 울산광역시 동구 방어진순환도로 1000 ',
  tel: '대표전화 : 052-202-2114',
  legal: '법적고지',
  email: '이메일무단수집거부',
  'email-address': '이메일',
  'header-ci': 'ci_ko',
  'footer-ci': 'footer_ci_ko',
  'i18n-btn': 'mdi-syllabary-hangul',
  'etc': '비고',
  // 버튼
  'label.retrieve': '조회', // 조회
  'label.save': '저장', // 저장
  'label.delete': '삭제', // 삭제
  'label.add': '추가', // 추가
  'label.conversion': '위치변환', // 변환
  'label.selection': '파일선택', // 파일선택
  'label.search': '검색', // 검색
  'label.to-search': '검색', // 검색
  'label.all-registration': '일괄등록', // 일괄등록
  'label.registration': '등록', // 등록
  'label.allocation': '할당', // 할당
  'label.copy': '복사', // 복사
  'label.download-excel': '엑셀 다운로드', // 엑셀 다운로드
  'label.upload-excel': '엑셀 업로드', // 엑셀 업로드
  'label.template': '템플릿', // 템플릿
  'label.duplicate-check': '중복확인', // 중복확인
  'label.select-equipment': '장비선택', // 장비선택
  'label.parent-dev-select': '부모장비선택', // 부모장비선택
  'label.select': '선택', // 선택
  'label.reset': '초기화', // 초기화
  'label.check': '확인', // 확인
  'label.update': '수정', // 수정
  'label.select-file': '파일선택', //  파일선택
  'label.apply': '적용', // 적용
  'label.download': '다운로드', // 다운로드
  'label.cancel': '취소', // 취소
  'label.equipment-type-mapping': '장비유형 설정', // 장비유형 매핑
  'label.minW': '최소 가로',
  'label.minH': '최소 세로',
  'label.temp-save': '임시 저장',
  // 메세지
  'msg.save': '저장되었습니다.',
  'msg.update': '수정되었습니다.',
  'msg.delete': '삭제되었습니다.',
  'msg.essential': '필수값을 입력해주세요.',
  'msg.category-required-chart': '카테고리가 필수인 차트입니다.',
  'msg.delete-selected-template': '선택한 템플릿을 삭제하시겠습니까?',
  'msg.delete-ok': '삭제하시겠습니까?',

  'msg.api-name-double-checked': 'API명 중복확인을 해야 합니다.',
  'msg.url-double-checked': 'URL 중복확인을 해야 합니다.',
  'msg.duplicate-header': '중복된 Header가 있습니다.',
  'msg.duplicate-body': '중복된 Body가 있습니다.',
  'msg.api-save': 'API 저장이 완료되었습니다.',
  'msg.api-update': 'API 수정이 완료되었습니다.',
  'msg.no-delete-target': '삭제대상이 없습니다.',
  'msg.api-name-no': 'API명이 없습니다.',
  'msg.url-no': 'URL이 없습니다.',
  'msg.no-value-select': '선택한 값이 없습니다.',
  'msg.no-value-entered': '입력한 값이 없습니다.',

  'msg.duplicate-code': '중복된 코드입니다.',

  'msg.unregistered-equipment-property': '등록되지 않은 장비 속성입니다.',
  'msg.no-file-select': '선택된 파일이 없습니다.',
  'msg.no-date-select': '선택된 데이터가 없습니다.',
  'msg.xlsx-upload-only': '.xlsx 파일만 업로드 가능합니다.',
  'msg.excel-upload-success': '엑셀 업로드에 성공하였습니다.',
  'msg.excel-upload-fail': '엑셀 업로드에 실패하였습니다.',
  'msg.select-required-equipment': '할당할 장비를 선택하세요.',
  'msg.only-one-equipment': '복사 대상 장비는 하나만 선택 가능합니다.',
  'msg.assignment-customer-number': '할당할 고객번호를 입력하세요.',
  'msg.customer-number-no': '존재하지 않는 고객번호입니다.',
  'msg.customer-number': '존재하는 고객번호입니다.',
  'msg.model-id-enter': '모델 아이디를 입력하세요.',
  'msg.model-id-duplication': '중복된 모델 아이디가 존재합니다.',
  'msg.duplicate-check-completed': '중복 체크가 완료되었습니다.',
  'msg.do-check-model-id': '모델 아이디에 대한 중복 체크를 하셔야합니다.',
  'msg.save-complete': '저장이 완료되었습니다.',
  'msg.save-error': '저장 중 오류가 발생하였습니다.',
  'msg.select-row-delete': '삭제할 Row를 선택해주세요.',
  'msg.save-fail-try-again': '저장에 실패하였습니다. 잠시후 다시 시도해주세요.',
  'msg.non-entry-equipment': '입력되지 않은 장비속성이 있습니다.',
  'msg.non-entry-equipment-set': '입력되지 않은 장비속성SET이 있습니다.',
  'msg.non-entry-ideal-set': '입력되지 않은 이상징후SET이 있습니다.',

  'msg.select-program-name': '프로그램명을 선택해주세요.',
  'msg.select-template-name': '템플릿명을 선택해주세요.',
  'msg.select-template-type': '템플릿 구분을 선택해주세요.',
  'msg.select-template-image': '템플릿 이미지를 선택해주세요.',

  'msg.date-correct-enter': '시작년월, 종료년월을 올바르게 입력하세요.',
  'msg.date-cannot-great': '시작년월은 종료년월보다 클 수 없습니다.',
  'msg.inquiry-date-maximum7': '조회 기간은 최대 7일까지 선택 가능합니다.',
  'msg.no-file-download': '다운로드할 파일이 없습니다.',
  'msg.inquire-only-until-today': '오늘 날짜까지만 조회 가능합니다.',

  'msg.no-reception-select': '선택된 수신자가 없습니다.',
  'msg.no-entr-device-select': '선택된 가입장비가 없습니다.',
  'msg.registration-complete': '등록이 완료되었습니다.',
  'msg.registration-fail-try-again':
    '등록에 실패하였습니다. 잠시 후 다시 시도해주세요.',
  'msg.no-code-select': '선택된 코드가 없습니다.',

  'msg.period-Invalid': '조회기간이 잘못되었습니다.',
  'msg.check-use-number': '사용번호에 대한 중복 확인이 필요합니다.',
  'msg.check-installation-number': '설치번호에대한 중복 확인이 필요합니다.',
  'msg.check-required-value': '필수값을 확인해주세요.',
  'msg.use-number-enter': '사용번호를 입력해주세요.',
  'msg.duplicate-check-complete': '중복 체크가 완료되었습니다.',
  'msg.duplicate-use-number': '중복된 사용번호 입니다.',
  'msg.installation-number-check': '설치번호를 확인해주세요.',
  'msg.duplicate-installation-number': '중복된 설치번호 입니다.',
  'msg.excel-upload-only': '엑셀 파일만 업로드 가능합니다.',
  'msg.img-upload-only': '이미지 파일만 업로드 가능합니다.',

  'msg.equipment-modification-complete': '장비 수정이 완료되었습니다.',
  'msg.error-try-again':
    '장비 등록 에러가 발생하였습니다. 잠시후 다시 시도해주세요.',
  'msg.equipment-registration-completion': '장비 등록이 완료되었습니다.',
  'msg.no-selected-organization': '선택된 조직이 없습니다.',
  'msg.excel-download-completed': '엑셀 다운로드가 완료되었습니다.',
  'msg.warn.min-size-greater-than-0': '최소 사이즈는 0보다 커야 합니다.',
  'msg.warn.never-been-modified': '한번도 수정된 적이 없습니다.',
  'msg.common.question.save': '저장하시겠습니까?',

  'menu-management': '메뉴 관리',
  'top-menu': '최상위 메뉴',
  'system-code': '시스템 코드',
  'menu-list': '메뉴 목록',
  'list-add': '목록 추가',
  'label.menuList.button01': '프로그램 목록 팝업으로 추가',
  'label.menuList.button02': 'Excel 팝업으로 저장',
  'label.menuList.button03': 'Root메뉴 추가',
  'label.collective-registration': '일괄등록',
  'focused-node': '포커스된 노드',

  'menu-log-management': '메뉴로그 관리',
  'login-user-management': '접속자 관리',
  'login-ip': '로그인 IP 구분',

  affiliation: '소속',
  id: '아이디',
  'menu-id': '메뉴 아이디',
  'korean-title': '한글 제목',
  'label.shortcut': '바로가기',
  'menu-information': '메뉴 정보',
  'menu-delete': '메뉴 삭제',
  'menu-type': '메뉴 형식',
  'expanding-if-folder': '폴더인 경우 펼침 여부',
  'designate-program-id': '프로그램 아이디 지정',
  'label.popup': '팝업',
  'change-icon': '아이콘 변경',
  sequence: '순서',
  'menu-enabled': '메뉴 사용 여부',
  'korean-display-name': '한글 표시명',
  'custom-practice': 'Custom 수행 방식',
  'more-information-1': '추가 정보-1',
  'more-information-2': '추가 정보-2',
  'more-information-3': '추가 정보-3',
  'multilingual-information': '다국어 정보',
  'save-multilinguals': '다국어 저장',
  'label.add-selected-programs': '선택된 프로그램 추가',
  'label.add-selected': '선택 추가',
  system: '시스템',
  'common-code': '공통 코드',
  'common-code-management': '공통 코드 관리',
  'system-management': '시스템 관리',
  'system-name': '시스템 명',
  'program-name': '프로그램 명',
  'program-management': '프로그램 관리',
  'label.adding-to-file': '파일로 추가',
  'label.add-row': '행 추가',
  'label.upload-manual': '메뉴얼(다국어) 업로드',
  'target-language': '대상 언어',
  'manage-permission-groups': '권한그룹 관리',
  'permission-groups-code': '그룹 코드',
  'permission-groups-name': '그룹 명',
  'permission-groups-menu': '권한그룹별 메뉴',
  'user-group-code': '사용 그룹 코드',
  'api-group-auth-management': 'API별 그룹권한 관리',
  'expanded-auth': '확장 권한',
  'enter-exauth': '추가 할 확장권한 아이디를 입력하세요',
  'delete-node': '자식이 하나라도 존재하면 삭제할 수 없습니다.',
  name: '이름',
  'eng-name': '영문명',
  position: '직급',
  classification: '업무 구분',
  'group-id': '그룹 아이디',
  'group-name': '그룹이름',
  'permission-group': '권한그룹별 메뉴 권한 추가',
  'auth-to-user': '권한별 사용자',
  code: '코드',
  group: '그룹',
  'group-list': '그룹 목록',

  'etc-org-management': '비인사 조직 관리',
  'etc-user-edit': '사외 사용자 수정',
  'new-etc-org-management': '조직 관리',
  'etc-org-information': '조직 정보',
  'etc-org-list': '조직 리스트',
  'etc-org-title': '조직명',
  'etc-org-full-title': '조직명(전체)',
  'etc-org-delete': '조직 삭제',
  'etc-org-asgn-cd-check': '중복확인',
  'etc-org-type': '조직 형식',
  'etc-org-asgn-cd': '조직 코드',
  'etc-org-enabled': '조직 사용여부',
  'etc-org-bsns-cd': '부문 코드',
  'etc-org-dept-cd': '부서 코드',
  'label.etc-org-list.button1': '조직 추가',

  'etc-user-edit2': '사외 사용자 수정2',
  'etc-user-add': '사외 사용자 등록',
  'etc-user-management': '비인사 사용자 관리',
  'enter-organization-name': '추가할 조직명을 입력하세요.',
  menu: '메뉴',
  'label.adding-to-group': '그룹에 추가',
  'menu-by-group': '그룹별 메뉴',
  'menu-per-user-permissions': '사용자별 메뉴 권한',
  user: '사용자',
  'equipment-status': '장비별 통계 현황',
  'equipment-type': '장비유형',
  date: '일자',
  'device-rule': '장비 모델 룰 관리',
  sortation: '구분',
  'api-name': 'API 명',
  'terminal-type': '단말 유형',
  api: 'API',
  tcp: '수집 룰 설정',
  'verification-rule': '검증룰',
  'model-list': '모델 목록(Conversion)',
  'conversion-list': '단말별 룰 목록(Conversion)',
  'server-name': '서버명',
  parsingul: '파싱룰',
  'parsingul-professional': '파싱룰(전문)',
  'mapping-rule': '매핑룰',
  'service-call': '서비스호출',
  'service-name': '서비스 명',
  'equipment-model': '장비모델',
  'name-equipment': '장비명',
  'number-use': '사용번호',
  uuid: 'UUID',
  'installation-number': '설치번호',
  'item-number': '기물번호',
  'equipment-image': '장비이미지',
  'registration-date': '장비등록일자',
  'management-organization': '관리조직',
  'installation-date': '장비설치일자',
  'collection-cycle': '수집주기',
  'transfer-cycle': '전송주기',
  'equipment-condition': '장비상태',
  // IOT API 관리
  add: '추가',
  delete: '삭제',
  'collection-Communication-success': '수집/통신 성공률',
  'client-company': '고객사',
  // 장비 모델 관리
  api_management: 'API 관리',
  'label.initialization': '초기화',
  url: 'URL',
  'server-division': '서버구분',
  choice: '선택',
  'template-division': '템플릿 구분',
  explanation: '설명',
  header: 'HEADER',
  'device-model-management': '장비 모델 관리',
  'usage-status': '사용여부',
  manufacturer: '제조사',
  'model-name': '장비 모델명',
  'device-property': ' 장비속성',
  'device-property-set': ' 장비속성 SET',
  'device-property-anomalies': '장비속성 이상징후',
  property: '속성',
  'model-id': '장비모델 ID',
  'customer-number': '고객번호',
  target: '대상',
  'parents-device-id': '부모장비 ID',
  'disability-alarm-setting': '이상징후 알람 설정',
  'recipients-list': '수신자 목록',
  'shipment-type': '발송유형',
  'shipment-content': '발송내용',
  'organization-list': '조직도',
  'organization': '조직',
  'dashboard-setting': '대시보드 설정',
  'label.editing': '편집',
  'add-widget': '위젯 추가',
  'label.close': '닫기',
  'smm-sending-status': 'SMS 발송현황',
  period: '기간',
  'shipping-period': '발송기간',
  kind: '종류',
  'sms-shipment-history': 'SMS 발송 이력',
  'recipients-number': '수신자번호',
  'phone': '휴대폰 번호',
  'office-tel': '사무실 번호',
  'message-type': '메세지유형',
  rating: '등급',
  title: '제목',
  key: '키',
  label: '라벨',
  'y-axis-label': 'Y축 라벨',
  category: '카테고리',
  'select-template': '템플릿 선택',
  'list-template': '템플릿 목록',
  'list-widget': '위젯 목록',
  'template-settings': '템플릿 설정',
  'chart-component': '차트 컴포넌트',
  'control-history': '제어이력',
  'control-type': '제어종류',
  'control-status': '제어상태',
  'template-management': '템플릿 관리',
  'template-name': '템플릿명',
  'template-id': '템플릿ID',
  'template-type': '템플릿 구분',
  'template-img': '템플릿 이미지',
  language: '언어설정',
  'character-set': '문자셋',
  'template-header': '템플릿 헤더',
  'template-header-name': '템플릿 헤더 명',
  index: '인덱스',
  'equipment-retrieveData': '장비 회수데이터',
  'response-time': '응답시간',
  'time-setting': '시간설정',
  'equipment-attribute': '가입장비 속성',
  'service-management': '서비스 관리',
  'code-value': '코드값',
  'code-name': '코드명',
  'normal-icon': '정상 아이콘',
  'abnormal-icon': '이상 아이콘',
  'stop-icon': '정지 아이콘',
  // 2019년 5월 27일 추가 PKS
  // API 그룹 권한 관리를 위한 메세지
  'ApiGroupAuthManagement.title': 'API 그룹 권한 관리',
  'ApiGroupAuthManagement.subtitle1': '그룹 정보',
  'ApiGroupAuthManagement.subtitle2': 'API 목록 조회',
  'ApiGroupAuthManagement.subtitle3': '그룹별 API 목록',
  // API 개인별 권한 관리를 위한 메세지
  'ApiPersonalAuthManagement.title': '개인별 API 권한 관리',
  'ApiPersonalAuthManagement.subtitle.personal': '사용자 ID',
  'ApiPersonalAuthManagement.subtitle.api': 'API 목록 조회',
  'ApiPersonalAuthManagement.subtitle.auth': '개인별 API 권한',
  'ApiPersonalAuthManagement.label.person': '개인에 추가',
  'ApiPersonalAuthManagement.label.id': '사용자 ID',
  'ApiPersonalAuthManagement.label.name': '사용자 이름',
  'ApiPersonalAuthManagement.label.system': '시스템',
  'ApiPersonalAuthManagement.label.controller': 'controller',
  // API별 권한 부여 현황 관리
  'ApiAuthListMangement.title': 'API별 권한 관리',
  'ApiAuthListMangement.subtitle.api': 'API리스트 검색',
  'ApiAuthListMangement.subtitle.person': 'API 개인별 리스트',
  'ApiAuthListMangement.subtitle.group': 'API 그룹별 리스트',
  'ApiAuthListMangement.label.apiquery': 'API 검색 조건',

  // API 목록 관리를 위한 메세지
  'ApiInfoManagement.title': 'API 정보 관리',
  'ApiInfoManagement.subtitle1': '조회 조건',
  // API 목록 관리를 위한 메세지
  'ApiInfoManagement.lbl1': 'Controller',
  'ApiInfoManagement.lbl2': 'URI',

  // 엣지 관리
  'EdgeManagement.title': '엣지정보',
  'EdgeManagement.label.type': '엣지유형선택',
  'EdgeManagement.label.edge-name': '엣지명',
  'EdgeManagement.edge-popup.title': '엣지정보설정',

  // 장비제어
  'EquipmentControl.title': '장비제어',
  'EquipmentControl.subtitle': '장비유형',
  'EquipmentControl.label.control': '제어',
  'EquipmentControl.label.treatment': '처리구분',
  'EquipmentControl.label.reservation-time': '예약시간',
  'EquipmentControl.label.cancelReservation': '예약취소',
  'EquipmentControl.label.timeSynchronisation': '시간동기화',

  select_none: '없음',

  // 현황 화면 컬럼 설정
  'dynamicColumn.title': '동적 화면 컬럼 설정',
  'dynamicColumn.label.title': '장비유형',

  // 이상징후 설정
  'anomalies.title': '이상징후 속성',
  'anomalies.subtitle.equipment': '가입장비 기준',
  'anomalies.subtitle.alarm-method': '알람전송 방법',
  'anomalies.subtitle.alarm-title': '알람제목',
  'anomalies.subtitle.alarm-content': '알람내용',

  // 복합룰속성
  'complex-property': '복합속성',
  'general-property': '장비속성',
  'complex-equipment': '복합속성 조건식 정의',

  // 이차트
  'line-chart': '선 차트',
  'polar-bar-chart': '폴라 바 차트',
  'bar-chart': '바 차트',
  'gauge-chart': '게이지 차트',
  'pie-chart': '파이 차트',
  'dynamic-chart': '실시간 차트',

  // 이상징후 발송이력
  'disability-history': '이상징후 발송이력',

  // 위젯 관리
  'widget-management': '위젯 관리',

  'my-page': '마이페이지'
}

export default messages
